import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Layout/Home/Home";
import TracerNano from "./Layout/TracerNanoXR/TracerNano";
import PortalConsol from "./Layout/PortalConsol/PortalConsol";
import PortalCTQ from "./Layout/PortalCTQ/PortalCTQ";
import ProductionSchedule from "./Layout/ProductSchedule/ProductionSchedule";
import ConfigrationMain from "./Layout/ConfigrationMain2/ConfigrationMain";
import Configration from "./TracerComponents/MainHeader/Configration";
import { Login } from "./Component/Login/Login";
import User from "./Component/User/User";
import Billing from "./Component/Billing/Billing";
import Account from "./Component/Account/Account";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/trs" element={<TracerNano />} />
        <Route path="/portalConsole" element={<PortalConsol />} />
        <Route path="/portalCTQ" element={<PortalCTQ />} />
        <Route path="/ProductSchedule" element={<ProductionSchedule />} />
        <Route path="/ConfigMain" element={<ConfigrationMain />} />
        <Route path="/Configration" element={<Configration />} />
        <Route path="/user" element={<User />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/account" element={<Account />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
